export default __webpack_public_path__ + "static/media/Josie 9781408331477.ff217644.jpg";